//import config from '../config';
import React,{Component} from "react";
//import Paper from "@material-ui/core/Paper";
import Tab from "@material-ui/core/Tab";
import { Tabs,Box } from "@material-ui/core";
// from "@material-ui/core/Tabs";
import LeaveManager from "./AdminLeaveManager";
import AdminLE from "./AdminLE";
import AdminLeaveCancel from "./AdminLeaveCancel";
import AdminLeavesDetail from "./AdminLeavesDetail";
import Cookies from "universal-cookie";
import Leavedetail_all from "./Leavedetail_all_2";

const cookies = new Cookies();

const axios = require("axios");
const ref = React.createRef();
class AdminLeaveManagement extends Component{
    constructor(props)
    {
        super(props);
           this.state={value:0,tab1:"block",tab2:"none",tab3:"none",tab4:"none",tab5:"none",path:cookies.get("phpclass").substring(0,cookies.get("phpclass").length-3)};
    }    
    render(){
        return(
            <div className="containera1">
                <p style={{float:"right", width:"100px"}}>HEAD OFFICE</p>
                    <Box position="static"  >
                        <Tabs
                            value={this.state.value}
                            textColor="inherit"
                            indicatorColor="secondary"
                            style={{marginLeft:"50px"}}
                            onChange={(event, newValue) => {if(newValue == 0) this.setState({value:newValue,tab1:"block",tab2:"none",tab3:"none",tab4:"none",tab5:"none"}); else if(newValue == 1) this.setState({value:newValue,tab1:"none",tab2:"block",tab3:"none",tab4:"none",tab5:"none" }); else if(newValue == 2) this.setState({value:newValue,tab1:"none",tab2:"none",tab3:"block",tab4:"none",tab5:"none"}); else if(newValue == 3) this.setState({value:newValue,tab1:"none",tab2:"none",tab3:"none",tab4:"block",tab5:"none"}); else this.setState({value:newValue,tab1:"none",tab2:"none",tab3:"none",tab4:"none",tab5:"block"}) ;                                                             
                            }}
                            >
                            <Tab label="Leave detail / balance" > </Tab> 
                            <Tab label="Leave encashment"></Tab>
                            <Tab label="Leave Cancellation"></Tab>
                            <Tab label="Leave Detail Report"></Tab>
                            <Tab label="Leave Detail All"></Tab>
                        </Tabs>
                    </Box>
{/*}                    </div>*/}
                    <div  style={{display:this.state.tab1,marginLeft:"10%"}}>
                            <LeaveManager apipath={this.state.path+"ci2"}/>
                    </div>

{/*Tab 2*/}

                    <div  style={{display:this.state.tab2,marginLeft:"10%"}}>
                        <AdminLE apipath={this.state.path+"ci2"}/>
                    </div>
                    <div  style={{display:this.state.tab3,marginLeft:"10%"}}>
                        <AdminLeaveCancel apipath={this.state.path+"ci2"}/>
                    </div>
                    <div  style={{display:this.state.tab4,marginLeft:"10%"}}>
                        <AdminLeavesDetail apipath={this.state.path+"ci2"}/>
                    </div>
                    <div  style={{display:this.state.tab5,marginLeft:"10%"}}>
                        <Leavedetail_all apipath={this.state.path+"ci2"}/>
                    </div>
                    <br></br><br></br>
                </div>
/*}            </div>*/
    )}
}
export default AdminLeaveManagement;